<template><div><h1>VUX V2.7.6 发布日志</h1>
<h2><a href="/zh-CN/components/datetime.html">Datetime</a></h2>
<ul><li>[fix] 列的值使用number类型，修正绑定值与datetimepicker值不相等 #2296</li>
</ul>
<h2><a href="/zh-CN/components/inline-calendar.html">InlineCalendar</a></h2>
<ul><li>[feature] 添加事件 on-select-single-date</li>
</ul>
<h2><a href="/zh-CN/components/swiper.html">Swiper</a></h2>
<ul><li>[enhance] 只有一张图片时阻止滑动跟随</li>
</ul>
<h2><a href="/zh-CN/components/x-input.html">XInput</a></h2>
<ul><li>[feature] 增加disabled样式 #2279</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.7.6 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.7.6-264.vue?15f5c562